import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, AbstractControlDirective, ValidationErrors } from '@angular/forms';

@Component({
  selector: '[formControlError]',
  template: '<small *ngIf="shouldShowErrors()" role="alert" class="form-message">{{errorMessage}}</small>'
})
export class FormFieldErrorComponent implements OnInit {

  @Input() private formControlError: AbstractControlDirective | AbstractControl;
  private isHidden = true;
  private isValid: boolean = null;
  private errorMessage: string;
  private nativeElement: HTMLInputElement;
  private nativeElementWrapper: HTMLDivElement = null;
  private nativeFieldName: string = null;
  private isAdditionalErrorVisible: Element;

  constructor() {}

  ngOnInit(): void {
    this.nativeElement = this.formControlError['formNativeElement'] as HTMLInputElement;

    if (this.nativeElement) {
      this.nativeElementWrapper = this.nativeElement.closest('.form-input') as HTMLDivElement;

      this.nativeFieldName = this.nativeElement ? this.nativeElement.name : null;
    }
  }

  shouldShowErrors(): boolean {
    const instantValidationFields: string[] = [
      'customerCode', 'idSeriesNumber', 'idExpiryDate', 'city', 'companyNumber', 'regon', 'legalizeDate'
    ];

    const shouldValidateOnFocus: boolean = this.formControlError?.dirty && instantValidationFields.includes(this.nativeFieldName);
    this.isAdditionalErrorVisible = this.nativeElementWrapper?.querySelector('.error-wrapper > .additional-error');

    if (
      this.formControlError &&
      this.formControlError.errors &&
      (shouldValidateOnFocus || (!shouldValidateOnFocus && this.formControlError.touched))
    ) {
      if (this.isAdditionalErrorVisible) {
        this.isAdditionalErrorVisible.remove();
      }
      this.errorMessage = this.getErrorMessage();
      this.isHidden = false;
      this.isValid = false;
    } else if (
      this.formControlError &&
      this.formControlError.errors === null &&
      (this.formControlError.dirty || this.formControlError.touched)
    ) {
      this.errorMessage = '';
      this.isHidden = true;
      this.isValid = true;
    } else {
      this.errorMessage = '';
      this.isHidden = true;
      this.isValid = null;
    }

    this.changeParentClassName();

    return !this.isHidden;
  }

  private getErrorMessage(): string {
    const errors: ValidationErrors = Object.assign({}, this.formControlError.errors);

    if (errors && errors['required']) return 'Pole jest wymagane';

    return Object.values(errors)[0]?.msg || '';
  }

  private changeParentClassName(): void {
    if (this.nativeElementWrapper) {
      if (!this.isHidden || this.isAdditionalErrorVisible) {
        this.nativeElementWrapper.classList.add('error');
      } else {
        this.nativeElementWrapper.classList.remove('error');
      }

      if (this.isValid === true && !this.isAdditionalErrorVisible) {
        this.nativeElementWrapper.classList.add('success');
      } else {
        this.nativeElementWrapper.classList.remove('success');
      }
    }
  }

}
